import { parseDate } from "web_myplann/Shared/Utils/parseDate";

export const getRetirementPortfolioEndYear = (
	endAt: string | null | undefined,
): number | undefined => parseDate(endAt)?.getFullYear();
